import { Project } from '@brg/api';

export const OTHER_PROJECTS_WIDE_VIEW_TYPES = [
  't-shape',
  'fixed-ratio-small',
  'fixed-ratio-large',
  'horizontal',
  'animated',
] as const;

export type OtherProjectsMetaPlan = {
  showTitle: boolean;
  showAuthorPlain: boolean;
  showSummary: boolean;
  showAnnotationAuthor: boolean;
  showAnnotationText: boolean;
};

export const getProjectCoverViewType = (
  project: Project,
  projectType?: string,
): string =>
  String(
    project?.longread?.viewType ||
      projectType ||
      (project as { projectType?: string })?.projectType ||
      'container',
  );

export const isWideCoverViewType = (viewType: string): boolean =>
  OTHER_PROJECTS_WIDE_VIEW_TYPES.includes(
    viewType as (typeof OTHER_PROJECTS_WIDE_VIEW_TYPES)[number],
  );

export const isProLargeLandingCover = (project: Project): boolean =>
  Boolean(
    project?.isAdaptiveCard &&
      (project?.projectType === 'fixed-ratio-large' ||
        (project as { projectType?: string })?.projectType === 'fixed-ratio-large'),
  );

export const isHorizontalSameHeightCover = (viewType: string): boolean =>
  viewType === 'horizontal';

export const isNarrowLongreadViewType = (viewType: string): boolean =>
  viewType === 'fixed-ratio-small';

const getNarrowDesktopMetaPlan = (
  hasAiSummary: boolean,
  hasAnnotation: boolean,
  hasAuthors: boolean,
): OtherProjectsMetaPlan => ({
  showTitle: false,
  showAuthorPlain: false,
  showSummary: hasAiSummary,
  showAnnotationAuthor: hasAnnotation && hasAuthors,
  showAnnotationText: hasAnnotation,
});

export const getOtherProjectsMetaPlan = (params: {
  viewType: string;
  isCompactViewport: boolean;
  isProLargeLanding: boolean;
  hasAiSummary: boolean;
  hasAnnotation: boolean;
  hasAuthors: boolean;
}): OtherProjectsMetaPlan | null => {
  const {
    viewType,
    isCompactViewport,
    isProLargeLanding,
    hasAiSummary,
    hasAnnotation,
    hasAuthors,
  } = params;

  const isWide = isWideCoverViewType(viewType);
  const isHorizontal = isHorizontalSameHeightCover(viewType);
  const isNarrowLongread = isNarrowLongreadViewType(viewType);
  const isEmpty = !hasAiSummary && !hasAnnotation;

  if (isNarrowLongread && !isCompactViewport) {
    if (isEmpty) {
      return null;
    }
    return getNarrowDesktopMetaPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (
    isEmpty &&
    !isCompactViewport &&
    (isHorizontal || (isProLargeLanding && isWide))
  ) {
    return null;
  }

  if (isProLargeLanding && isCompactViewport) {
    return getVerticalCompactPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (isWide && !isProLargeLanding) {
    return getWideCoverPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (isWide && isProLargeLanding && !isCompactViewport) {
    if (isEmpty) return null;
    return getWideCoverPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (!isWide && isCompactViewport) {
    return getVerticalCompactPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (!isWide && !isCompactViewport) {
    if (isEmpty) return null;
    return getNarrowDesktopMetaPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  return null;
};

function getWideCoverPlan(
  hasAiSummary: boolean,
  hasAnnotation: boolean,
  hasAuthors: boolean,
): OtherProjectsMetaPlan {
  if (!hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: false,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  if (!hasAiSummary && hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: false,
      showSummary: false,
      showAnnotationAuthor: hasAuthors,
      showAnnotationText: true,
    };
  }

  if (hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: true,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  return {
    showTitle: true,
    showAuthorPlain: false,
    showSummary: true,
    showAnnotationAuthor: hasAuthors,
    showAnnotationText: true,
  };
}

function getVerticalCompactPlan(
  hasAiSummary: boolean,
  hasAnnotation: boolean,
  hasAuthors: boolean,
): OtherProjectsMetaPlan {
  if (!hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: false,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  if (hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: true,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  if (hasAiSummary && hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: false,
      showSummary: true,
      showAnnotationAuthor: hasAuthors,
      showAnnotationText: true,
    };
  }

  return {
    showTitle: true,
    showAuthorPlain: false,
    showSummary: false,
    showAnnotationAuthor: hasAuthors,
    showAnnotationText: true,
  };
}
import { Project } from '@brg/api';

export const OTHER_PROJECTS_WIDE_VIEW_TYPES = [
  't-shape',
  'fixed-ratio-small',
  'fixed-ratio-large',
  'horizontal',
  'animated',
] as const;

export type OtherProjectsMetaPlan = {
  showTitle: boolean;
  showAuthorPlain: boolean;
  showSummary: boolean;
  showAnnotationAuthor: boolean;
  showAnnotationText: boolean;
};

export const getProjectCoverViewType = (
  project: Project,
  projectType?: string,
): string =>
  String(
    project?.longread?.viewType ||
      projectType ||
      (project as { projectType?: string })?.projectType ||
      'container',
  );

export const isWideCoverViewType = (viewType: string): boolean =>
  OTHER_PROJECTS_WIDE_VIEW_TYPES.includes(
    viewType as (typeof OTHER_PROJECTS_WIDE_VIEW_TYPES)[number],
  );

export const isProLargeLandingCover = (project: Project): boolean =>
  Boolean(
    project?.isAdaptiveCard &&
      (project?.projectType === 'fixed-ratio-large' ||
        (project as { projectType?: string })?.projectType === 'fixed-ratio-large'),
  );

export const isHorizontalSameHeightCover = (viewType: string): boolean =>
  viewType === 'horizontal';

export const isNarrowLongreadViewType = (viewType: string): boolean =>
  viewType === 'fixed-ratio-small';

const getNarrowDesktopMetaPlan = (
  hasAiSummary: boolean,
  hasAnnotation: boolean,
  hasAuthors: boolean,
): OtherProjectsMetaPlan => ({
  showTitle: false,
  showAuthorPlain: false,
  showSummary: hasAiSummary,
  showAnnotationAuthor: hasAnnotation && hasAuthors,
  showAnnotationText: hasAnnotation,
});

export const getOtherProjectsMetaPlan = (params: {
  viewType: string;
  isCompactViewport: boolean;
  isProLargeLanding: boolean;
  hasAiSummary: boolean;
  hasAnnotation: boolean;
  hasAuthors: boolean;
}): OtherProjectsMetaPlan | null => {
  const {
    viewType,
    isCompactViewport,
    isProLargeLanding,
    hasAiSummary,
    hasAnnotation,
    hasAuthors,
  } = params;

  const isWide = isWideCoverViewType(viewType);
  const isHorizontal = isHorizontalSameHeightCover(viewType);
  const isNarrowLongread = isNarrowLongreadViewType(viewType);
  const isEmpty = !hasAiSummary && !hasAnnotation;

  if (isNarrowLongread && !isCompactViewport) {
    if (isEmpty) {
      return null;
    }
    return getNarrowDesktopMetaPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (
    isEmpty &&
    !isCompactViewport &&
    (isHorizontal || (isProLargeLanding && isWide))
  ) {
    return null;
  }

  if (isProLargeLanding && isCompactViewport) {
    return getVerticalCompactPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (isWide && !isProLargeLanding) {
    return getWideCoverPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (isWide && isProLargeLanding && !isCompactViewport) {
    if (isEmpty) return null;
    return getWideCoverPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (!isWide && isCompactViewport) {
    return getVerticalCompactPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  if (!isWide && !isCompactViewport) {
    if (isEmpty) return null;
    return getNarrowDesktopMetaPlan(hasAiSummary, hasAnnotation, hasAuthors);
  }

  return null;
};

function getWideCoverPlan(
  hasAiSummary: boolean,
  hasAnnotation: boolean,
  hasAuthors: boolean,
): OtherProjectsMetaPlan {
  if (!hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: false,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  if (!hasAiSummary && hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: false,
      showSummary: false,
      showAnnotationAuthor: hasAuthors,
      showAnnotationText: true,
    };
  }

  if (hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: true,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  return {
    showTitle: true,
    showAuthorPlain: false,
    showSummary: true,
    showAnnotationAuthor: hasAuthors,
    showAnnotationText: true,
  };
}

function getVerticalCompactPlan(
  hasAiSummary: boolean,
  hasAnnotation: boolean,
  hasAuthors: boolean,
): OtherProjectsMetaPlan {
  if (!hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: false,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  if (hasAiSummary && !hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: true,
      showSummary: true,
      showAnnotationAuthor: false,
      showAnnotationText: false,
    };
  }

  if (hasAiSummary && hasAnnotation) {
    return {
      showTitle: true,
      showAuthorPlain: false,
      showSummary: true,
      showAnnotationAuthor: hasAuthors,
      showAnnotationText: true,
    };
  }

  return {
    showTitle: true,
    showAuthorPlain: false,
    showSummary: false,
    showAnnotationAuthor: hasAuthors,
    showAnnotationText: true,
  };
}
